import { FC } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { SHRED_CARD, SHRED_REWARD_CARD } from '@lootboy/lib/lootcoinBoni';

import Alert from '~/components/Alert';
import BottomPopupWithTransition from '~/components/BottomPopupWithTransition';
import Body, { ICardsShredPopupBody } from '~/components/CardsShredPopup/Body';
import { componentWrappers } from '~/components/PopupsWithTransition';

import { emitSound, MONEY_SHOT, SHRED } from '~/redux/actions/SoundActions';

import { ESuffix } from './ESuffix';
import Footer from './Footer';

import styles from './CardsShredPopup.module.scss';

interface ICardsShredPopup extends Omit<ICardsShredPopupBody, 'suffix'> {
  shred: () => Promise<void>;
  show: boolean;
  closePopup: () => void;
}

const CardsShredPopup: FC<ICardsShredPopup> = ({
  cards: cardsUnfiltered,
  changeCardState,
  shred,
  show,
  closePopup,
}) => {
  const dispatch = useDispatch();
  const alert = useAlert();

  const cards = cardsUnfiltered.filter(Boolean);
  const suffix = cards.length > 1 ? ESuffix.plural : ESuffix.singular;
  const lootcoinBonus = cards.reduce(
    (acc, card) => acc + (card.reward ? SHRED_REWARD_CARD : SHRED_CARD),
    0,
  );

  const shredWrapper = async () => {
    dispatch(emitSound(SHRED));
    shred().catch((err: { message?: string }) => {
      alert.error(
        <Alert
          body={err.message}
          title={I18n.t('CardDetailView_error_shred_failed')}
        />,
      );
    });
    // todo: This is very simple fix. Sound handling by queue should be considered.
    setTimeout(() => dispatch(emitSound(MONEY_SHOT)), 1000);
  };

  return (
    <BottomPopupWithTransition
      banner={I18n.t(`CardDetailView_confirm_shred_header${suffix}`)}
      bannerClassName={styles.shredPopupBanner}
      body={
        <Body
          cards={cards}
          changeCardState={changeCardState}
          suffix={suffix}
        />
      }
      className=""
      componentWrapper={componentWrappers.BottomPopupTransitionFilterWrapper}
      closeButtonEnabled
      closeButtonClassName={styles.closeButton}
      containerClassName={classNames(styles.popup)}
      disableCloseAnimation
      footer={
        <Footer
          cancelShredding={closePopup}
          shredCards={shredWrapper}
          suffix={suffix}
          bonus={lootcoinBonus}
        />
      }
      onClose={closePopup}
      show={show}
    />
  );
};

export default CardsShredPopup;
